import React, { useEffect, useContext, useState, useRef } from "react";

import { LayoutContext } from "App/common/hoc/Layout";
import { connect } from "react-redux";

function UpgradePlanConfirmation(props) {
  const { lState, lMethods } = useContext(LayoutContext);
  const [confirm, setConfirm] = useState(false);
  const lStateRef = useRef();
  useEffect(() => {
    if (confirm && !props.commonLoader.upgrade) {
      lMethods.closePopup();
    }
  }, [props.commonLoader.upgrade, confirm]);

  /*****************************Handling  popup using enter key ***************************/

  useEffect(() => {
    lStateRef.current = lState;
    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        lStateRef.current.popup.show &&
        lStateRef.current.popup.alertName === "upgradePlan"
      ) {
        props.execute();
        setConfirm(true);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [lState]);

  function formSubmitHandler(e) {
    e.preventDefault();
    props.execute();
    setConfirm(true);
  }

  return (
    <div className="confirmation_payment">
      <p style={{}}>
        {" "}
        <span className="cp_title">Selected Plan:</span>{" "}
        <span className="normalPrice" id>
          {props.plans.data &&
            props.plans.data.plans.find(v => v.id === props.body.planId)
              .description}
        </span>{" "}
      </p>
      <p className="amount_list_out">
        Amount Payable:
        <span className="strikePl">
          $
          {props.plans.data &&
            props.plans.data.plans.find(v => v.id === props.body.planId)
              .yearlyFee}
        </span>
        <span className="amtClr"> ${props.body.AMOUNT}</span>{" "}
      </p>
      <p id className="description">
        Your card will be charged, once you click the Continue button.
      </p>
      <form onSubmit={e => formSubmitHandler(e)}>
        {props.commonLoader.upgrade ? (
          <div className="cp_continue_btn">
            <div className="btn_primary" style={{ width: "130px" }}>
              <img
                src={
                  process.env.REACT_APP_STATIC_URL + "/images/submit_loader.gif"
                }
                alt="loader"
              />
            </div>
          </div>
        ) : (
          <div className="cp_continue_btn">
            <input type="submit" className="btn_primary" value="Continue" />
          </div>
        )}
      </form>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    plans: state.common.plans,
    commonLoader: state.account.commonLoader
  };
}

export default connect(mapStateToProps)(UpgradePlanConfirmation);
